import { render, staticRenderFns } from "./Internal-Payment.vue?vue&type=template&id=62e4ba08"
import script from "./Internal-Payment.vue?vue&type=script&lang=js"
export * from "./Internal-Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports